export default {"src":"/_next/static/media/medicine.6600598b.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};